const $ = require('jquery');

'use strict';

const PLUGIN_NAME = 'webslider';

const DEFAULTS = {
  minScreenWidth: 768,
  data: [],
  slideContentFormatter(data) {
    let result = '';
    result += '<ul>';
    for (let i = 0; i < data.length; i++) {
      result += '<li>';

      if (data[i].motive) {
        result += `<img src="${data[i].motive}" class="img-responsive" alt="">`;
      }

      if (data[i].title && data[i].title != '') {
        result += '<div class="description">';
        result += '<div class="description-wrapper">';
        result += '<div class="container">';
        if (data[i].sign && data[i].sign != '') {
          result += `<h2 class="sign sign-${data[i].sign}">${data[i].title}</h2>`;
        } else {
          result += `<h2>${data[i].title}</h2>`;
        }
        if (data[i].description && data[i].description != '') {
          result += `<p>${data[i].description}</p>`;
        }
        if (data[i].link && data[i].link != '' && data[i].linkName && data[i].linkName != '') {
          result += `<p class="buttons"><a href="${data[i].link}" class="btn">${data[i].linkName}</a></p>`;
        }
        result += '</div>';
        result += '</div>';
        result += '</div>';
      }
      result += '</li>';
    }
    result += '</ul>';
    return result;
  },
  controlArrows: true,
  controlPoints: true,
  slideTime: 8000,
};

// The actual plugin constructor
function WebSlider(element, options) {
  this.element = element;

  this.options = $.extend(true, {}, DEFAULTS, options);
  this._wWidth = window.innerWidth;

  this._defaults = DEFAULTS;
  this._name = PLUGIN_NAME;

  this._changeTimer = null;

  this.initialise();
}

/**
 * init
 */
WebSlider.prototype.initialise = function () {
  if (this._wWidth < this.options.minScreenWidth && document.body.id !== 'voda') {
    $(this.element).empty().hide();
    return false;
  }
  $(this.element).show();
  this.actualSlide = 0;

  if (this.options.data.length > 0) {
    this.renderSlides();
  }

  if (this.options.data.length > 1) {
    this.renderControls();
    this.startRotation();
  }
};

/**
 * read data and build slides list
 */
WebSlider.prototype.renderSlides = function () {
  const htmlResult = this.options.slideContentFormatter(this.options.data);
  $(this.element).html(htmlResult);
};

/**
 * render controls
 */
WebSlider.prototype.renderControls = function () {
  this.controlArrows = (this.options.controlArrows) ? this.renderControlArrows() : null;
  this.controlPoints = (this.options.controlPoints) ? this.renderControlPoints() : null;

  if (this.controlArrows) {
    $(this.element).append(this.controlArrows);
    this.bindControlArrows();
  }

  if (this.controlPoints) {
    $(this.element).append(this.controlPoints);
    this.bindControlPoints();
    this.updateControlPoints(this.actualSlide);
  }
};

/**
 * renders control arrows
 */
WebSlider.prototype.renderControlArrows = function () {
  let str = '';
  str += '<span class="slider-arrow prev"></span>';
  str += '<span class="slider-arrow next"></span>';
  return str;
};

/**
 * bind action to control arrows
 */
WebSlider.prototype.bindControlArrows = function () {
  const self = this;
  $('span.slider-arrow', $(this.element)).bind('click', function () {
    clearTimeout(this._changeTimer);
    if ($(this).hasClass('prev')) {
      self.rotate(self.actualSlide, 'prev');
    }

    if ($(this).hasClass('next')) {
      self.rotate(self.actualSlide, 'next');
    }
  });
};

/**
 * renders control points
 */
WebSlider.prototype.renderControlPoints = function () {
  let str = '<ul class="control-points">';
  for (let i = 0; i < this.options.data.length; i++) {
    str += `<li>${i}</li>`;
  }
  str += '</ul>';
  return str;
};

/**
 * bind action to control points
 */
WebSlider.prototype.bindControlPoints = function () {
  const self = this;
  clearTimeout(this._changeTimer);

  $('.control-points>li', $(this.element)).bind('click', function () {
    self.changeSlide(self.actualSlide, $(this).text());
  });
};

/**
 *
 */
WebSlider.prototype.rotate = function (from, direction) {
  let newSlide = this.actualSlide;
  clearTimeout(this._changeTimer);
  if (direction == 'prev') {
    newSlide--;
    newSlide = (newSlide < 0) ? this.options.data.length - 1 : newSlide;
  }

  if (direction == 'next') {
    newSlide++;
    newSlide = (newSlide >= this.options.data.length) ? 0 : newSlide;
  }

  this.changeSlide(this.actualSlide, newSlide);
};

/**
 *
 * @param from
 * @param to
 */
WebSlider.prototype.changeSlide = function (from, to) {
  if (from == to) {
    return false;
  }
  $(`>ul:first>li:eq(${from})`, $(this.element)).hide();
  $(`>ul:first>li:eq(${to})`, $(this.element)).show();
  this.actualSlide = to;
  this.updateControlPoints(this.actualSlide);
  this.startRotation();
};


/**
 * start
 */
WebSlider.prototype.startRotation = function () {
  const self = this;
  clearTimeout(this._changeTimer);
  this._changeTimer = setTimeout(() => {
    self.rotate(self.actualSlide, 'next');
  }, self.options.slideTime);
};

/**
 * sets the right controlPoint active
 */
WebSlider.prototype.updateControlPoints = function (index) {
  if (this.options.controlPoints) {
    $('.control-points li', $(this.element)).removeClass('active');
    $(`.control-points li:eq(${index})`, $(this.element)).addClass('active');
  }
};

/**
 * decide, which methods will be "public"
 */
const API = {
  // action: WebSlider.prototype.action
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
  const args = arguments;

  return this.each(function () {
    const $this = $(this);

    // get plugin instance
    let plugin = $this.data(`plugin_${PLUGIN_NAME}`);

    // if there's not, create one
    if (!plugin) {
      plugin = new WebSlider(this, value);
      $this.data(`plugin_${PLUGIN_NAME}`, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value](...Array.prototype.slice.call(args, 1));
    }
  });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.webslider.js